import React from 'react'
import Navbar, { NAVBAR_HEIGHT } from '../../Components/Navbar'
import { Box, Container, Typography, useMediaQuery } from '@mui/material'
import BGContainer from '../../Components/BGContainer';
import OftenAsked from '../../Components/OftenAsked';
import { theme } from '../../Resources/Design/theme';
import { fullCenter, pastelOrange, textStyle, titleStyle } from './constants';
import TematickeProgramy from './TematickeProgramy';
import MotionAppear from '../../Components/MotionAppear';
import bgpattern from './bgpattern.jpg';
import About from '../About/About';
import { Motion } from '../../Components/Motion';
import { Link, useNavigate } from 'react-router-dom';
import { EditableTypography } from '../../Components/EditableTypography';
import Centered from '../../Components/Centered';
import EditableImage from '../../Components/EditableImage';
import { logAnalytics } from '../../Firebase/firebase_init';
import FabPhone from '../../Components/FabPhone';
import { ReactComponent as PhoneIcon } from './PhoneIcon.svg';

const minHeight = 620;
const shadow = 0.3;

export const RezervovatButton = ({ link = "rezervace", sublink = "", sx = {}, double = false, buttons = true, reverse = false, sxTextBox = {}, sxButton = {} }) => {
    const shadow = 0.1;
    return <Box sx={{ display: 'flex', flexDirection: reverse ? 'column-reverse' : 'column', pt: '120px', ...sx }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', ...fullCenter, ...sxTextBox }}>
            <EditableTypography fireKey={'quest_phone'} right={-40} bottom={5} sx={{ ...textStyle, pb: '8px', fontWeight: 'bold' }} />
            <Motion scale={1.02}>
                <Box sx={{ display: 'flex', flexDirection: 'row', p: '4px', cursor: 'pointer', textDecoration: 'none' }} component={'a'} href='tel:+420777120048'>
                    <PhoneIcon style={{ width: '24px', height: '24px', display: 'block' }} />
                    <Typography sx={{ ...textStyle, textWrap: 'nowrap', ml: '6px', mr: '2px' }}>+420 777 120 048</Typography>
                </Box>
            </Motion>
        </Box>

        {buttons && <>
            <MotionAppear amount={0.5}>
                <Box sx={{ width: '100%', ...fullCenter, pt: '40px', ...sxButton }}>
                    <Motion scale={1.02} style={{ width: 'fit-content' }}>
                        <Box component={Link} to={`/${link}${sublink}`} aria-label='Rezervovat tábor' sx={{
                            width: '200px', height: '50px', borderRadius: '32px', bgcolor: pastelOrange,
                            ...fullCenter, cursor: 'pointer', boxShadow: '1px 1px 2px 0px rgba(0,0,0,0.2)',
                            textDecoration: 'none',
                        }} onClick={() => {
                            logAnalytics("form_navigation");
                        }}>
                            <EditableTypography comment={'All reserve buttons text'} fireKey={'reserve'} bottom={-50} noPropagation={true} sx={{
                                ...textStyle, fontSize: '18px', fontWeight: 500, color: 'white', textShadow: `
      1px 1px 2px rgba(0,0,0,${shadow}),
      -1px -1px 2px rgba(0,0,0,${shadow}),
      1px -1px 2px rgba(0,0,0,${shadow}),
      -1px 1px 2px rgba(0,0,0,${shadow})
    ` }} />

                        </Box>
                    </Motion>
                </Box></MotionAppear>
            {double && <MotionAppear amount={0.5}>
                <Box sx={{ width: '100%', ...fullCenter, pt: '40px', ...sxButton }}>
                    <Motion scale={1.02} style={{ width: 'fit-content' }}>
                        <Box component={Link} to={`/${link}${sublink}`} aria-label='Rezervovat tábor' sx={{
                            width: '200px', height: '50px', borderRadius: '32px', bgcolor: pastelOrange,
                            ...fullCenter, cursor: 'pointer', boxShadow: '1px 1px 2px 0px rgba(0,0,0,0.2)',
                            textDecoration: 'none',
                        }} onClick={() => {
                            logAnalytics("kurz_form_navigation");
                        }}>
                            <EditableTypography comment={'All reserve buttons text'} fireKey={'kurz_reserve'} bottom={-50} noPropagation={true} sx={{
                                ...textStyle, fontSize: '18px', fontWeight: 500, color: 'white', textShadow: `
      1px 1px 2px rgba(0,0,0,${shadow}),
      -1px -1px 2px rgba(0,0,0,${shadow}),
      1px -1px 2px rgba(0,0,0,${shadow}),
      -1px 1px 2px rgba(0,0,0,${shadow})
    ` }} />

                        </Box>
                    </Motion>
                </Box></MotionAppear>}
        </>}

    </Box>;
}

export default function MainPage() {
    const lg = useMediaQuery(`(max-width:1200px)`);
    const xsm = useMediaQuery(`(max-width:1000px)`);
    const xxsm = useMediaQuery(`(max-width:800px)`);
    const xxs = useMediaQuery(`(max-width:650px)`);
    const xs = useMediaQuery(`(max-width:600px)`);
    const navigate = useNavigate();

    const mobile = useMediaQuery(theme.breakpoints.only("xs"));
    const MIN_HEIGHT = mobile ? 600 : 520;
    const MIN_WIDTH = mobile ? 1200 : 1000;

    const getTitleKey = () => {
        if (xs) {
            return "phone_title";
        }
        if (xxsm) {
            return "tablet_title";
        }
        return "title";
    }

    const getSubTitleKey = () => {
        if (xsm) {
            return "phone_learn";
        }
        if (lg) {
            return "tablet_learn";
        }
        return "learn";
    }

    return (
        <Box sx={{}}>
            <FabPhone />
            <Box sx={{
                width: "100%", position: "relative", minHeight: `${minHeight}px`, bgcolor: '#4a713c'
            }}>

                <EditableImage
                    fireKey={'img_bg'}
                    alt="happy kids camp"
                    sx={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                        zIndex: 1,
                    }}
                />


                <Box
                    sx={{
                        position: "relative",
                        maxWidth: 1200,
                        mx: "auto",
                        px: 2,
                        minHeight: `${minHeight}px`,
                        ...fullCenter,
                        alignItems: "flex-end",
                        alignContent: "flex-end",
                        zIndex: 2, // above background
                    }}
                >

                    <MotionAppear
                        style={{
                            position: "absolute",
                            zIndex: 5,
                            filter: "drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.6))",
                            top: xs ? "31%" : "28%",
                        }}
                    >
                        <Motion scale={1.01}>
                            <EditableImage
                                defaultVisible={true}
                                alt='uk flag'
                                fireKey={'img_flag'}
                                sx={{
                                    borderRadius: "20px",
                                    zIndex: 5,
                                    width: mobile ? "210px" : "240px",
                                    color: '#4a713c',
                                    textShadow: `
                            1px 1px 2px rgba(0,0,0,1),
                            -1px -1px 2px rgba(0,0,0,1),
                            1px -1px 2px rgba(0,0,0,1),
                            -1px 1px 2px rgba(0,0,0,1)
                        `,
                                }}
                            />
                        </Motion>
                    </MotionAppear>

                    <EditableTypography
                        fireKey={getTitleKey()}
                        component="h1"
                        variant="h3"
                        sx={{
                            fontFamily: "Quicksand",
                            fontSize: xs ? "34px" : "48px",
                            lineHeight: xs ? "40px" : "58px",
                            fontWeight: "bold",
                            maxWidth: xs ? "420px" : "auto",
                            color: "#fff",
                            textTransform: "uppercase",
                            mb: "120px",
                            zIndex: 12,
                            px: { xs: "0px", sm: xxs ? "0px" : "16px", md: "16px" },
                            textShadow: `
                    1px 1px 2px rgba(0,0,0,${shadow}),
                    -1px -1px 2px rgba(0,0,0,${shadow}),
                    1px -1px 2px rgba(0,0,0,${shadow}),
                    -1px 1px 2px rgba(0,0,0,${shadow})
                `,
                        }}
                    />
                </Box>
            </Box>


            {/*                        */}
            <BGContainer sx={{ py: '120px' }}>
                <Container maxWidth='lg' sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <EditableTypography component="h2" fireKey={getSubTitleKey()} sx={{ ...titleStyle, textAlign: 'center', mb: '120px', maxWidth: { xs: '500px', sm: '500px', md: '650px', lg: '1150px' } }} />
                    <Box sx={{ display: 'flex', flexDirection: xsm ? 'column' : 'row' }}>
                        <MotionAppear>
                            <EditableImage fireKey={'img_kids'} alt='kids playing outside' sx={{
                                maxWidth: xsm ? '100%' : '520px', borderRadius: '20px', objectFit: 'cover', maxHeight: xsm ? '400px' : 'auto',
                                boxShadow: '1px 1px 2px 0px rgba(0,0,0,0.2)'
                            }} />
                        </MotionAppear>
                        <EditableTypography fireKey={'text1'} sx={{ ...textStyle, ml: xsm ? '0px' : '24px', mt: xsm ? '64px' : '0px' }} />
                    </Box>
                    <RezervovatButton />
                </Container>
            </BGContainer>

            <Box
                sx={{
                    backgroundSize: "500px 500px",
                    backgroundImage: `url(${bgpattern})`,
                    backgroundRepeat: "repeat",
                }}
            >
                <BGContainer id={"programy"} sx={{ bgcolor: "rgba(255, 128, 0, 0.5)" }}>
                    <Container maxWidth='lg' sx={{ py: '120px' }}>
                        <TematickeProgramy />
                    </Container>
                </BGContainer>
            </Box>

            <BGContainer sx={{ bgcolor: "white" }}>
                <Container maxWidth='lg' sx={{ my: '120px', }}>
                    <OftenAsked />
                    <RezervovatButton />
                </Container>
            </BGContainer>

        </Box >
    )
}
